import { render, staticRenderFns } from "./BaseUserDetails.vue?vue&type=template&id=12a522f3&"
import script from "./BaseUserDetails.vue?vue&type=script&lang=js&"
export * from "./BaseUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports